import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { TOAST_CONFIGS, CustomToaster } from "./utils/toast";
import Routes from "./routes";
import { Elements, RecurlyProvider } from "@recurly/react-recurly";
import { connect } from "react-redux";
import { GetMyProfile } from "./redux/profile/actions";
//bootstrap
// import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/js/bootstrap.bundle';
// import 'jquery/dist/jquery.js';
const App = (props) => {
    useEffect(() => {
        console.log(`UPDATE(${process.env.REACT_APP_ENVIRONMENT}) - 2025-03-06:1`);
        if (localStorage.getItem("access-token")) {
            props.GetMyProfile();
        }
    }, []);

    return (
        <BrowserRouter>
            <RecurlyProvider
                publicKey={process.env.REACT_APP_RECURLY_PUBLIC_KEY}
            >
                <Elements>
                    <Routes />
                </Elements>
            </RecurlyProvider>
            <Toaster id="indi-toaster" {...TOAST_CONFIGS} children={CustomToaster} />
        </BrowserRouter>
    );
};

const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, {
    GetMyProfile,
})(App);
